export const saveToLocalStorage = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value))
}

export const fetchFromLocalStorage = key => {
  return JSON.parse(window.localStorage.getItem(key))
}